export default __webpack_public_path__ + "static/media/my_picture.6e90948b.png";